import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import Recruit from '@/components/recruit'
import About from '@/components/about'
import Culture from '@/components/culture'
import Service from '@/components/Service'
import Feedback from '@/components/feedback'
import Contact from '@/components/contact'
import Engineering from '@/components/engineering'
import Engineerings from '@/components/engineerings'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Recruit',
      name: 'Recruit',
      component: Recruit
    },
    {
      path: '/About/',
      name: 'About',
      component: About
    },
    {
      path: '/Culture/',
      name: 'Culture',
      component: Culture
    },
    {
      path: '/Service/',
      name: 'Service',
      component: Service
    },
    {
      path: '/Feedback',
      name: 'Feedback',
      component: Feedback
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/Engineering',
      name: 'Engineering',
      component: Engineering
    },
    {
      path: '/Engineerings/:ID',
      name: 'Engineerings',
      component: Engineerings
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js